import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  InputGroup,
  NavLink,
  Row,
  Accordion,
  Table,
} from "react-bootstrap";
import dummy_coach1_sqr from "../../../assets/images/icons/user.png";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import axios from "axios";

import moment from "moment";
import Lottie from "react-lottie";
import { Link, useNavigate } from "react-router-dom";
import noDataLottie from "../../../assets/lottieFiles/noData.json";
import { useUserContext } from "../../../utils/hooks/UserContext";

const baseURL = `${process.env.REACT_APP_LOCAL_BASE_URL}`;

function MyProgramsComponents() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: noDataLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const { fetchNotifications, notification, unreadNotification } =
    useUserContext();

  useEffect(() => {
    console.log("notiiiiion");
    fetchNotifications();
  }, []);

  const formatDuration = (totalMinutes) => {
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    return [
      days > 0 ? `${days} day${days > 1 ? "s" : ""}` : "",
      hours > 0 ? `${hours} hour${hours > 1 ? "s" : ""}` : "",
      minutes > 0 ? `${minutes} min${minutes > 1 ? "s" : ""}` : "",
    ]
      .filter(Boolean) // Remove empty values
      .join(", ");
  };
  const [allSession, setAllSession] = useState([]);
  const [allSessions, allSessionOfUser] = useState([]);

  const [myCoachList, setMyCoachList] = useState([]);
  const [selectedCoach, setSelectedCoach] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [programType, setProgramType] = useState("");

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },
        url: `${baseURL}/coach/program/user-session-list`,
      };
      const resp = await axios(options);
      setAllSession(resp.data.data);
      allSessionOfUser(resp.data.data);
      const listOptions = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },
        url: `${baseURL}/coach/program/users-coach-list`,
      };
      const listResp = await axios(listOptions);
      setMyCoachList(listResp.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleCoachFilter = async (e) => {
    try {
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },
        url: `${baseURL}/coach/program/user-session-list?client_id=${e}&status=${selectedStatus}&program_type=${programType}`,
      };
      const resp = await axios(options);
      setAllSession(resp.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleStatusFilter = async (status) => {
    try {
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },
        url: `${baseURL}/coach/program/user-session-list?client_id=${selectedCoach}&status=${status}&program_type=${programType}`,
      };
      const resp = await axios(options);
      setAllSession(resp.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleProgramFilter = async (type) => {
    try {
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },
        url: `${baseURL}/coach/program/user-session-list?client_id=${selectedCoach}&status=${selectedStatus}&program_type=${type}`,
      };
      const resp = await axios(options);
      setAllSession(resp.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();

  const sendData = (item) => {
    console.log("ttttttttt", item);
    navigate("/user/schedule-session", { state: { sessionData: item } });
  };

  const [searchText, setSearchText] = useState("");

  // 🔍 Filter sessions based on coach_name
  useEffect(() => {
    setAllSession(
      allSessions.filter((item) =>
        item.coach_name.toLowerCase().includes(searchText.toLowerCase())
      )
    );
    if (searchText == "") {
      setAllSession(allSessions);
    }
  }, [searchText]);

  return (
    <>
      <Row className="mb-3 align-items-center justify-content-between">
        <Col xs="4">
          <div className="text-start hdng_a">
            <h2 className="m-0">My Programs</h2>
          </div>
        </Col>
        <Col xs="5">
          <InputGroup size="sm" className="mb-3">
            <Form.Control
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <Button>
              <i className="bi bi-search"></i>
            </Button>
          </InputGroup>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col md="10">
          <Row className="gx-2 align-items-center">
            <Col>
              <Form.Select
                onChange={(e) => {
                  setSelectedCoach(e.target.value);
                  handleCoachFilter(e.target.value);
                }}
              >
                <option>Select Coach</option>
                {myCoachList.map((item) => (
                  <option key={item.coach_id} value={item.coach_id}>
                    {item.user_name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col>
              <Form.Select
                onChange={(e) => {
                  setSelectedStatus(e.target.value);
                  handleStatusFilter(e.target.value);
                }}
              >
                <option value="">Status</option>
                <option value="scheduled">Scheduled</option>
                <option value="pending">Pending</option>
                <option value="completed">Completed</option>
                <option value="cancelled">Cancelled</option>
              </Form.Select>
            </Col>
            <Col>
              <Form.Select
                onChange={(e) => {
                  setProgramType(e.target.value);
                  handleProgramFilter(e.target.value);
                }}
              >
                <option value="">Program Type</option>
                <option value="single">Single Day</option>
                <option value="multiple">MultiDay</option>
              </Form.Select>
            </Col>
          </Row>
        </Col>
      </Row>
      <section className="programs_list_sections">
        <div className="programs_list_header_card">
          <Row>
            <Col xs="4">
              <label className="fs-14 fw-500">Coach Name</label>
            </Col>
            <Col xs="6">
              <label className="fs-14 fw-500">Program Opted</label>
            </Col>
            <Col xs="2">
              <label className="fs-14 fw-500">Progress Status</label>
            </Col>
          </Row>
        </div>
        {allSession.length > 0 ? (
          allSession.map((item, index) => {
            const adjustedTime = moment.utc(item.start_time);
            const adjustedEndTime = moment.utc(item.end_time);
            const formattedStartTime = adjustedTime.format(
              "MMMM Do YYYY, HH:mm A"
            );
            const formattedEndTime = adjustedEndTime.format(
              "MMMM Do YYYY, HH:mm A"
            );

            const startTime = moment(
              adjustedTime.format("YYYY-MM-DD HH:mm"),
              "YYYY-MM-DD HH:mm"
            );
            const endTime = moment(
              adjustedEndTime.format("YYYY-MM-DD HH:mm"),
              "YYYY-MM-DD HH:mm"
            );
            const durationInMinutes = endTime.diff(startTime, "minutes");
            return (
              <div className="programs_list_body_card" key={index}>
                <Row className="align-items-center">
                  <Col md="4">
                    <div className="d-flex align-items-center">
                      <span className="user_img">
                        <img
                          className="w-[2.6rem] h-[2.6rem] rounded-full object-cover "
                          width={62}
                          height={62}
                          src={
                            item.coach_profile
                              ? process.env
                                  .REACT_APP_COACH_PROFILE_FOLDER_PATH +
                                item.coach_profile
                              : dummy_coach1_sqr
                          }
                        />
                      </span>
                      <div className="ps-2">
                        <Link
                          to={`/browse-coach/coach-details/${item.coach_id}`}
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          <h5 className="fs-14 fw-500">{item.coach_name}</h5>
                        </Link>
                        {/* <p style={{ fontSize: '12px' }}>
                        {formattedStartTime + ' to ' + formattedEndTime}
                      </p> */}
                      </div>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="program_opted_bg">
                      {/* <div className="d-flex justify-content-end">

                      
                    </div> */}
                      <div className="d-flex justify-content-between align-items-center">
                        <h5 className="m-0 text_brand_color2 fs-15 fw-600">
                          {item.program_name}
                        </h5>
                        <div>
                          <p className="m-0 fs-12 fw-600">
                            Program:{" "}
                            {item.type === "single"
                              ? "Single Day"
                              : `${item?.days} Days`}{" "}
                            , ${item.price}
                          </p>

                          {/* <small className="fs-12 fw-600">Price:${item.price}</small> */}
                          <small className="fs-12 fw-600">
                            {formatDuration(item.duration)}
                          </small>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        {/* <small className="fs-12 fw-600">{item.duration} Min</small> */}
                        {/* <small className="fs-12 fw-500">Basic Emotional Intelligence</small> */}
                      </div>
                    </div>
                  </Col>
                  {/* {item.completed_percent !== 0 &&
                item.completed_percent !== null &&
                item.completed_percent !== undefined ? ( */}

                  {item.session_day_status == "scheduled" ||
                  item.session_day_status == "completed" ||
                  (item.type === "multiple" && item.session_completed > 0) ? (
                    <Col md="2">
                      <div style={{ width: 100, height: 100 }}>
                        <CircularProgressbar
                          styles={buildStyles({
                            textColor: "#14183E",
                            pathColor:
                              item.completed_percent < 30
                                ? "red"
                                : item.completed_percent >= 30 &&
                                  item.completed_percent < 80
                                ? "yellow"
                                : "green",
                            // trailColor: "#F9F9F9",
                            trailColor:
                              item.completed_percent < 30
                                ? "red"
                                : item.completed_percent >= 30 &&
                                  item.completed_percent < 80
                                ? "yellow"
                                : "green",
                          })}
                          strokeWidth={14}
                          text={`${item.session_completed}/${item.total_sessions}`}
                          value={item.completed_percent}
                          maxValue={10}
                        />
                      </div>
                    </Col>
                  ) : item.type === "single" ? (
                    <Col>
                      <div className="d-grid">
                        <Button
                          className="fs-12 fw-600"
                          variant="success"
                          size="lg"
                          onClick={() => sendData(item)}
                        >
                          Schedule <br /> Session
                        </Button>
                      </div>
                    </Col>
                  ) : (
                    ``
                  )}
                  {item.type === "multiple" && item.session?.length > 0 && (
                    <Col md="10">
                      <Accordion defaultActiveKey="0" className="mt-3">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            {item.session.length} Sessions
                          </Accordion.Header>
                          <Accordion.Body>
                            <Table className="m-0 align-middle borderless_td">
                              <tbody>
                                {item.session.map((subSession, index) => {
                                  const isDisabled =
                                    subSession.session_day_status ===
                                      "scheduled" ||
                                    subSession.session_day_status === "live" ||
                                    subSession.session_day_status ===
                                      "completed";
                                  return (
                                    <tr key={index}>
                                      <td className="fs-14 fw-500 text_brand_color7">
                                        {subSession.session_title} (
                                        {formatDuration(subSession.duration)}){" "}
                                      </td>
                                      <td className="text-end">
                                        <div className="">
                                          <Button
                                            className="px-4 fw-600 btn-sm"
                                            variant={
                                              isDisabled
                                                ? "secondary"
                                                : "success"
                                            } // Greyed out when disabled
                                            onClick={() => {
                                              if (!isDisabled) {
                                                sendData(subSession);
                                              }
                                            }}
                                            disabled={isDisabled} // Disable when scheduled
                                            style={{
                                              fontSize: "12px", // Super small text
                                              padding: "2px 5px", // Minimal padding
                                              minWidth: "50px", // Reduce button width
                                              minHeight: "25px", // Reduce button height
                                              lineHeight: "1", // Tighten text spacing
                                            }}
                                          >
                                            {isDisabled ? (
                                              "Scheduled"
                                            ) : (
                                              <>Schedule Session</>
                                            )}
                                          </Button>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </Col>
                  )}
                </Row>
              </div>
            );
          })
        ) : (
          <Col>
            <Lottie
              options={defaultOptions}
              height={300}
              width={400}
              isStopped={false}
              isPaused={false}
            />
          </Col>
        )}
      </section>
    </>
  );
}

export default MyProgramsComponents;
